// Approval-first builds: before the request is sent, write the customer's full configuration
// (variant options, chosen extras, estimated price) into the hidden "Build details" field so
// the store's contact email shows exactly what to review and invoice.
const clean = (text) => String(text || '').replace(/\s+/g, ' ').trim();

function buildSummary(details) {
  const productForm = document.getElementById(details.dataset.productFormId || '');
  const lines = [`Product: ${details.dataset.productTitle || ''}`];

  if (productForm) {
    for (const select of productForm.querySelectorAll('s-variant-picker select')) {
      const label = clean(select.closest('fieldset')?.querySelector('legend')?.textContent) || select.name;
      lines.push(`${label}: ${clean(select.selectedOptions[0]?.textContent)}`);
    }

    const extras = [];
    for (const select of document.querySelectorAll(`select[data-addon-select][form="${CSS.escape(productForm.id)}"]`)) {
      const choice = clean(select.selectedOptions[0]?.textContent);
      if (!choice || /^none selected$/i.test(choice)) continue;
      extras.push(`${clean(select.labels?.[0]?.textContent) || select.name}: ${choice}`);
    }
    lines.push(extras.length ? `Extras: ${extras.join('; ')}` : 'Extras: none');

    const variantId = productForm.elements.namedItem('id')?.value;
    if (variantId) lines.push(`Page: ${location.origin}${location.pathname}?variant=${variantId}`);
  }

  const price = clean(document.querySelector('[data-product-price] bdi')?.textContent);
  if (price) lines.push(`Estimated price each: ${price}`);

  return lines.join('\n');
}

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  const details = form.querySelector('[data-build-approval]');
  const summary = form.querySelector('[data-build-summary]');
  if (!details || !summary) return;
  summary.value = buildSummary(details);
});
